/**
 * Keeps only the add-on ids the guest is actually offered. A pre-selected id
 * (URL param, stored selection) can name an add-on the guest must never get,
 * such as a hidden one. Returns the same array when nothing is dropped so a
 * state setter built on it does not trigger a re-render.
 */
export function keepOfferedAddonIds(
  ids: string[],
  offered: ReadonlyArray<{ id: string }>,
): string[] {
  const allowed = new Set(offered.map((addon) => addon.id));
  const kept = ids.filter((id) => allowed.has(id));

  return kept.length === ids.length ? ids : kept;
}
